<template>
  <form @submit.prevent="submitForm">
    <label for="input1">{{ inputLabel }}</label>
    <div class="input-group has-validation" :class="{ filled : inputValue }">
      <input class="form-control" :class="{ 'is-invalid' : formValidation && !formIsValid }" type="text" :placeholder="inputPlaceholder" :aria-label="action" id="input1" v-model="inputValue">
      <button class="btn btn-primary" :disabled="!formIsValid">{{ action }}</button>
    </div>
    <div class="invalid-feedback" v-if="formValidation && !formIsValid">{{ errorMessage }}</div>
    <small v-if="!formValidation" class="input-info">{{ inputInformation }}</small>
  </form>
</template>

<script>
export default {
  name: 'SingleForm',
  props: {
    action: String,
    errorMessage: String,
    inputInformation: String,
    inputLabel: String,
    inputType: String,
    inputPlaceholder: String,
    formIsValid: Boolean
  },
  data () {
    return {
      inputValue: null,
      formValidation: false
    }
  },
  watch: {
    inputValue: function (val) {
      if (typeof val !== 'undefined' && val !== '') {
        this.formValidation = true
        this.$emit('input-value', this.inputValue)
      } else {
        this.formValidation = false
      }
    }
  },
  methods: {
    submitForm () {
      this.$emit('form-submitted', this.inputValue)
    }
  }
}
</script>

<style scoped>
  form {
    display: flex;
    flex-wrap: wrap;
  }

  label {
    font-size: .875rem;
    width: 100%;
  }

  .input-group {
    border: 1px solid var(--input-border-default);
    border-radius: .375rem;
    padding: 3px;
  }

  input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: var(--input-placeholder);
    opacity: 1; /* Firefox */
  }

  .input-group:hover {
    border-color: var(--input-border-hover);
  }

  .input-group:hover input::placeholder {
    color: var(--input-placeholder-hover);
  }

  .input-group.filled {
    border-color: var(--input-border-filled);
  }

  .input-group .btn {
    border-top-left-radius: .25rem !important;
    border-bottom-left-radius: .25rem !important;
  }

  input {
    border: 0;
  }

  .input-info {
    font-size: .875rem;
    display: block;
    margin-top: .25rem;
    color: var(--input-info);
  }

  .invalid-feedback {
    display: block;
    color: var(--naega-red);
  }

  .fadeOut .input-group {
    border-color: transparent;
    justify-content: center;
  }

  .fadeOut .input-group .btn {
    background-color: var(--naega-green);
    border-color: var(--naega-green);
    margin-left: 0;
    animation: growBtn 1s forwards,
                bounceOut .5s 1s forwards;
  }

  .fadeOut .form-control {
    width: 0;
    padding: 0;
    flex-grow: 0;
    color: transparent;
  }

  .fadeOut label {
    opacity: 0;
  }

  .fadeOut small {
    opacity: 0;
  }

  @keyframes growBtn {
    from {
      width: 100%;
      color: transparent;
    }
    to {
      width: 100px;
      color: white;
    }
  }
</style>
